import React from 'react';
import { useGLTF } from '@react-three/drei';
import { GroupProps } from '@react-three/fiber';
import metabioticGltf from '../../../../../../static/gltf/Metabiotic/Metabiotic_compos_threejs-opt.glb';

const MODEL_URL = metabioticGltf;

function Metabiotic(props: GroupProps) {
    const { nodes } = useGLTF(MODEL_URL, true) as any;

    return (
        <group {...props} dispose={null}>
            <mesh
                geometry={nodes.Cube031.geometry}
                material={nodes.Cube031.material}
                position={[0, -0.006, 0]}
                scale={1.054}
            />
            <mesh
                geometry={nodes.Cube031_1.geometry}
                material={nodes.Cube031_1.material}
                position={[0, -0.006, 0]}
                scale={1.054}
            />
        </group>
    );
}

export default Metabiotic;
